import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Commands, Results } from '@local/client-contracts';
import { HighlightStyle } from '@shared/pipes';
import { HubService } from 'src/app/bar/services/hub.service';
import { TelemetryTrigger } from '../../models/results-types';
import { UiIconModel } from '@local/ui-infra';
import { getIconModel } from '@shared/utils/set-icon.util';

@Component({
  selector: 'result-subtitle',
  templateUrl: './result-subtitle.component.html',
  styleUrls: ['./result-subtitle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultSubtitleComponent implements OnInit {
  private _model: Results.Title;
  highlightStyle: HighlightStyle = 'default';
  iconModel: UiIconModel;

  @Input() set model(val: Results.Title) {
    this._model = val;
    this.iconModel = getIconModel(this.model?.icon);
  }
  @Input() highlights: Array<string>;
  @Output() invoke = new EventEmitter<{ command: Commands.Command; context: Partial<Commands.Context>; trigger: TelemetryTrigger }>();
  @ViewChild('subtitle', { read: ElementRef }) subtitleRef: ElementRef;

  get model(): Results.Title {
    return this._model;
  }

  constructor(private hubService: HubService) {}

  ngOnInit(): void {
  }


  @HostListener('click')
  onClick(): void {
    this.sendCommand(this.model?.onClick, null, 'mouse_click');
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    if (this.model.onRightClick) {
      this.sendCommand(this.model.onRightClick);
      event.stopPropagation();
    }
  }

  private sendCommand(command: Commands.Command, context: Partial<Commands.Context> = {}, trigger?: TelemetryTrigger) {
    if (!command) {
      return;
    }
    this.invoke.emit({ command, context, trigger });
  }

  get subtitleTooltipText() {
    const el: HTMLElement = this.subtitleRef?.nativeElement;
    if (!el) return;
    const width = el.clientWidth;
    const scrollWidth = el.scrollWidth;
    return width < scrollWidth ? this.model?.tooltip : '';
  }
}
